import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';
import styles from './annotationsSidebar.scss';
import annotationService from '../../services/AnnotationService';
import marketplacePropertiesService from '../../services/MarketplacePropertiesService';

const AnnotationsVisibilityButtonContent = ({ shouldShowVisibilityIcon, annotationsVisibility }) => {
    const title = annotationsVisibility ? t('header.hideAllAnnotations') : t('header.showAllAnnotations');
    const fontIcon = annotationsVisibility ? 'fa-eye' : 'fa-eye-slash';

    const toggleVisibility = () => {
        annotationService.setVisibility(!annotationsVisibility);
    };

    return shouldShowVisibilityIcon ? (<button
        className={styles.annotationsHeaderButton}
        id="annotationsVisibilityButton"
        aria-label={t('annotations.visibilityButton.ariaLabelText')}
        title={title}
        onClick={toggleVisibility}
    >
        <span className="sr-only">{title}</span>
        <i className={`fa ${fontIcon} fa-3`} aria-hidden="true" />
    </button>) : null;
};

AnnotationsVisibilityButtonContent.propTypes = {
    annotationsVisibility: PropTypes.bool.isRequired,
    shouldShowVisibilityIcon: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    const { studentHighlights: { annotationList, annotationsVisibility } } = state;
    const shouldShowVisibilityIcon = !marketplacePropertiesService.isToggleHighlightAndAnnotationsIconHidden() && annotationList.length !== 0;

    return {
        annotationsVisibility,
        shouldShowVisibilityIcon,
    };
}

const AnnotationsVisibilityButton = connect(mapStateToProps)(AnnotationsVisibilityButtonContent);

export default AnnotationsVisibilityButton;
